import HorizontalCard from "../productCards/horizontalCard";
import VerticalCard from "../productCards/verticalCard";
import {CashbackCustomerProductView, MembershipImage1, ToggleGif} from "../../../assets/assets";
import AdvanceCTABanner from "../../generalComponents/banners/advanceCTABanner";
import React, { useEffect, useState } from "react";
import VideoPlayer from "../../videoPlayer/VideoPlayer";

export default function SectionComponent(props) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <div className="my-20 space-y-4">

            <div className="text-black text-[64px] p-32 responsive-section" style={{backgroundColor: "#f5f5f7"}}>
                <div className="flex items-center justify-center">
                    <div>
                        <h1 className="my-8 text-center section-heading-c" style={{fontWeight: "600"}}>
                            Designed for status.
                        </h1>

                        <div className="flex justify-center">
                            <div className="mt-20 w-4/5 space-y-4 section-inner">

                                <HorizontalCard
                                    title="Attachable perks"
                                    description="Control everything. Memberships allow you to customize every payout, perk, and tier to perfectly match brand identity."
                                    imageSource={MembershipImage1}
                                    imagePosition={isMobile ? "bottom" : "right"}
                                    superSizeTitle={true}
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: "49%"}}>
                                        <VerticalCard
                                            title={
                                                <div>
                                                    Over 12K Shopify
                                                    <img className="w-20"
                                                         src="https://cdn3.iconfinder.com/data/icons/social-media-2068/64/_shopping-512.png"/>
                                                    retailers and counting.
                                                </div>
                                            }
                                            imagePosition="bottom"
                                            superSizeTitle={true}
                                            cardColor="black"
                                        />
                                    </div>
                                    <div style={{maxWidth: "49%"}}>
                                        <VerticalCard
                                            title={
                                                <div>
                                                    Pay-to-play or free entry.
                                                    <div className="mt-8 mb-12">
                                                        <VideoPlayer/>
                                                    </div>
                                                </div>
                                            }
                                            description="Monetize exclusivity. Offer curated membership tiers that customers can buy through your Shopify store. Or add customers to membership tiers ad hoc."
                                            cardColor="black"
                                        />
                                    </div>
                                </div>

                                <HorizontalCard
                                    title="Stop quitting things that have huge long-term potential because they make you feel uncomfortable in the present moment."
                                    description="Use any of our pre-built cashback templates that convert 30% better than generic offers."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/discovery_in_app__e2uo3q050wqe_large_2x.jpg"
                                    imagePosition="top"
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: "49%"}}>
                                        <VerticalCard
                                            title="Easily search across all Membership activites."
                                            description="Our comprehensive search feature offers suggestions and helpful hints, and provides results with in‑line video previews, editorial stories, tips and tricks, and lists."
                                            imageSource="https://www.apple.com/v/app-store/b/images/overview/icon_search__d0w979yulru6_large_2x.png"
                                            imagePosition="top"
                                            imageHeight="150px"
                                            imageMargin="176px"
                                        />
                                    </div>
                                    <div style={{maxWidth: "49%"}}>
                                        <VerticalCard
                                            title={
                                                <div>
                                                    Instantly issue <strong>Recurring Credits</strong> anytime. No
                                                    delays, no hassle.
                                                </div>
                                            }
                                            imageSource="https://images.pexels.com/photos/164686/pexels-photo-164686.jpeg"
                                            description={
                                                <div>
                                                    Premium members can distribute <strong>Recurring Credits</strong>.
                                                    This allows for custom amounts and frequencies in seconds to keep
                                                    engagement high and redemption rates climbing.
                                                </div>
                                            }
                                            imagePosition="top"
                                        />
                                    </div>
                                </div>

                                <div className="flex space-x-4 responsive-card-group-fix">
                                    <div className="card-wrapper">
                                        <VerticalCard
                                            title={
                                                <div>
                                                    Over 12K Shopify
                                                    <img className="w-20"
                                                         src="https://cdn3.iconfinder.com/data/icons/social-media-2068/64/_shopping-512.png"/>
                                                    retailers and counting.
                                                </div>
                                            }
                                            cardColor="black"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                    <div className="card-wrapper">
                                        <VerticalCard
                                            title="Priority queue on new product launches."
                                            cardColor="blue"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                </div>

                                <HorizontalCard
                                    title="Get the details on every app."
                                    description="App product pages give you the information you need when deciding what to download. From more videos to rankings and reviews, there are loads of ways to help you pick the app that’s right for you."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/discovery_details__bguw9nfi7w9u_large_2x.jpg"
                                    imagePosition={isMobile ? "top" : "left"}
                                />
                            </div>
                        </div>
                    </div>
                </div>


            </div>


            <div className="flex justify-center">
                <AdvanceCTABanner
                    text={<div>Want to try the app?<br/>Join the membership.</div>}
                    ctaString="Go Premium 💎"
                    imageSource="https://planzer.io/wp-content/uploads/2022/12/planzer-tasks-solved.svg"
                    secondaryCTAString={<div>
                        <span className="elementor-button-text">
                            Going Pro
                            <svg viewBox="0 0 2 2" aria-hidden="true"
                                 className="h-4 w-4 mx-2 inline size-0.5 fill-current">
                                <circle r={1} cx={1} cy={1}/>
                            </svg>
                            Start now
                        </span>
                    </div>}
                />
            </div>

            <div className="text-black text-[64px] p-32 responsive-section" style={{backgroundColor: "#f5f5f7"}}>
                <div className="flex items-center justify-center">
                    <div>
                        <h1 className="my-8 text-center section-heading-c" style={{fontWeight: "600"}}>
                            <div>Cashback is a Shopify retention tool.</div>
                            <div>Functioning as an engagement engine.</div>
                        </h1>

                        <div className="flex justify-center">
                            <div className="mt-20 w-4/5 space-y-4 section-inner responsive-card-group">


                                <HorizontalCard
                                    title="Consumer Rengagement (CR)"
                                    description="Consumer Rengagement (CR) is calculated by measuring the number of times you touch a consumer and the quality of that relationship. Pabloo members are offered a tool to use store credit as a relationship builder."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/privacy_security__c7ffaiitglg2_large_2x.jpg"
                                    imagePosition={isMobile ? "top" : "left"}
                                    superSizeTitle={true}
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="100% of apps are automatically screened for known malware."
                                            cardColor="blue"
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Always fresh. Always actionable."
                                            description="Members automatically receive recurring credits monthly or at your chosen frequency."
                                            imageSource="https://www.apple.com/v/app-store/b/images/overview/trust_guidelines__dcbhrjxc09km_large_2x.jpg"
                                            imagePosition={isMobile ? "top" : "top"}
                                        />
                                    </div>
                                </div>

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Over 16K apps use Apple health technologies like HealthKit, CareKit, and ResearchKit designed to protect patient privacy."
                                            cardColor="black"
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Every week, over 500 dedicated experts around the world review over 100K apps."
                                            imagePosition="top"
                                            superSizeTitle={true}
                                            cardColor="blue"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className="flex justify-center">
                <AdvanceCTABanner
                    text={<div>Explore what's next.<br/>Join the membership.</div>}
                    ctaString="Go Premium 💎"
                    imageSource="https://planzer.io/wp-content/uploads/2022/12/planzer-tasks-solved.svg"
                    secondaryCTAString={<div>
                        <span className="elementor-button-text">
                            Going Pro
                            <svg viewBox="0 0 2 2" aria-hidden="true"
                                 className="h-4 w-4 mx-2 inline size-0.5 fill-current">
                                <circle r={1} cx={1} cy={1}/>
                            </svg>
                            Start now
                        </span>
                    </div>}
                />
            </div>

            {/* Mobile-specific style overrides */}
            <style>
                {`
                        @media (max-width: 767px) {
                            .responsive-section {
                                font-size: 28px !important;
                                padding: 28px !important;
                            }

                            .section-heading-c {
                                font-size: 48px !important;
                                line-height: 1.3 !important;
                            }

                            .section-inner {
                                width: 100% !important;
                                margin-top: 2rem !important;
                            }

                            .responsive-card-group {
                                flex-direction: column !important;
                                gap: 1.5rem !important;
                                
                            }

                            .responsive-card-group > div {
                                max-width: 100% !important;
                                margin-left: 0 !important;
                            }

                            .responsive-card-group-fix {
                                flex-direction: column !important;
                                margin-top: 1.5rem !important;
                                gap: 1.5rem !important;
                            }

                            .responsive-card-group-fix > .card-wrapper {
                                width: 100% !important;
                                margin-left: 0 !important;
                            }
                        }
                    `}
            </style>
        </div>
    )
}